import { cannot } from '@/app/helpers'
import { createEmptyReminderCampaignItem } from '@/app/module/campaigns/models/reminder/transform'
import { CampaignTemplateType, LegacyCampaignItem } from '@/app/module/campaigns/types'

/**
 * This function initializes a campaign item object/instance based on the itemId and campaign type.
 * There are three possible scenarios:
 * 1. If itemId is provided, return the item. The item can be undefined (e.g.: it's being fetched) but we don't need to worry about that
 * since this function is only used when initializing a campaign item component. Any changes to item in store will be handled by the campaign item component.
 * 2. If itemId is not provided and the type is not a reminder, return a default campaign object with the type.
 * 3. If itemId is not provided and the type is a reminder, return a reminder campaign instance.
 */
export const getCampaignItem = (config: {
  item?: LegacyCampaignItem
  itemId?: number
  type: CampaignTemplateType
}): any => {
  const { item, itemId, type } = config
  // if itemId is provided, return the item
  if (itemId) {
    return item
  }

  switch (type) {
    case CampaignTemplateType.SMSBlast:
      return {
        type,
        variables: {
          message: {
            text: '',
          },
        },
      }

    case CampaignTemplateType.CATI:
    case CampaignTemplateType.Drip:
    case CampaignTemplateType.SMSSurvey:
    case CampaignTemplateType.VoiceBlast:
    case CampaignTemplateType.VoiceSurvey:
    case CampaignTemplateType.WhatsAppSurvey:
      return {
        type,
        variables: {
          parts: [],
        }, // initialize variables
      }

    case CampaignTemplateType.Chatbot:
      return {
        type,
        variables: {
          config: {
            model: 'gpt-4o-mini',
            prompt: '',
          },
        },
      }

    case CampaignTemplateType.Reminder:
      return createEmptyReminderCampaignItem()
    default:
      return cannot(type)
  }
}
